import { Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { DocumentStatusType } from "../../@types/enumsGlobal"
import { IDatePeriod } from "../../components/datePeriodPicker/datePeriodPicker"
import { DatePeriodPanelV2 } from "../DatePeriodPanelV2/DatePeriodPanelV2"
import styles from "./DocumentsFilteringPanelV2.module.scss"
import classNames from "classnames"

const { Option } = Select;

interface Props {
    datePeriod: IDatePeriod
    onDatePeriodChange: (value: IDatePeriod) => void
    multipleSelect?: boolean
    onMultipleSelectChange?: (value: boolean) => void
    plugin?: IPlugin
    documentStatusType?: DocumentStatusType | undefined
    onDocumentStatusTypeChange: (value: DocumentStatusType | undefined) => void
    tourRefs?: {
        datePeriod?: React.RefObject<HTMLDivElement>
        statusSelect?: React.RefObject<HTMLDivElement>
    }
}

export const DocumentsFilteringPanelV2: React.FC<Props> = (props) => {
    const { t } = useTranslation()
    
    const statusOptions = [
        { value: undefined, label: t("general.all") },
        { value: "draft", label: t("general.saved") },
        { value: "proc", label: t("general.worked") },
        ...((props.plugin === 'request_for_movement_create_plugin' || props.plugin === 'internet_order_create_plugin') ? [{ value: "secured", label: t("general.secured") }] : []),
        { value: "del", label: t("general.deleted") }
    ];
   
    return (
        <div className={styles.documentsFilteringPanelV2}>
            <div ref={props.tourRefs?.datePeriod}>
                <DatePeriodPanelV2
                    className={styles.documentsFilteringPanelV2__datePeriodPanelV2}
                    datePeriod={props.datePeriod}
                    onDatePeriodChange={(date: IDatePeriod) => {
                        props.onDatePeriodChange(date)
                    }}
                />
            </div>
            <div ref={props.tourRefs?.statusSelect}>
                <Select
                    className={classNames(
                        styles.documentsFilteringPanelV2__select, 
                        styles.customSelect
                    )}
                    style={{ width: '100%' }}
                    getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
                    value={props.documentStatusType}                    
                    onChange={(value) => {                       
                        props.onDocumentStatusTypeChange(value === undefined ? undefined : value as DocumentStatusType);
                    }}                    
                    defaultValue={undefined}
                    placeholder={"Выберите статус"}
                >
                    {statusOptions.map((opt) => (
                        <Option key={opt.value} value={opt.value}>
                            {opt.label}
                        </Option>
                    ))}
                </Select>
            </div>
        </div>
    )
}
